import {Component, OnInit, ViewChild} from '@angular/core';
import {
    ColumnFilter,
    DataTableColumnData, DatatableComponent,
    DataTableConfig,
    DataTableDataSource, DataTableObservableCompletionListener,
    DataTableObservableDataSource, DataTableObservableErrorListener, DataTableObservableRefresher, TableAction
} from '@cas-hub/acabim-common-client';
import {FinancialChartDetails} from '../_models/financial-account.model';
import {FinancialChartService} from '../_services/financial-chart.service';
import {map} from 'rxjs/operators';
import {MessageService, PrimeNGConfig} from 'primeng/api';

@Component({
    selector: 'acabim-admin-manage-classes',
    templateUrl: './manage-classes.component.html',
    styleUrls: ['./manage-classes.component.scss'],
    providers: [MessageService]
})
export class ManageClassesComponent implements OnInit {
    public dataSources: DataTableDataSource<any>[] = [];
    showAddModal = false;
    modalTitle = ' ';
    @ViewChild('dataTable') public dataTable?: DatatableComponent;

    constructor(private readonly financialService: FinancialChartService,
                private messageService: MessageService,
                private primengConfig: PrimeNGConfig) {
    }

    ngOnInit(): void {
        this.primengConfig.ripple = true;
        this.dataSources.push(new AccountClassDS(this.dataRefresher(), undefined, undefined, action => {
        }));
    }

    private dataRefresher(): DataTableObservableRefresher<FinancialChartDetails> {
        return () =>
            this.financialService.getAllClasses(true).pipe(map(data => {
                const classes: FinancialChartDetails[] = [];
                data.forEach(d => {
                    d.details.status = d.details.status === 1 ? 'active' : 'inactive';
                    classes.push(d.details);
                });
                return classes;
            }));
    }

    toogleStatus($event: boolean) {

        if ($event) {
            if (this.dataSources[0].detailData) {
                this.modalTitle = 'Edit Account Class';
            } else {
                this.modalTitle = 'Add Account Class';
            }
        } else {
            this.dataSources[0].detailData = undefined;
        }
        this.showAddModal = $event;

    }

    closeModal($event: string) {
        this.toogleStatus(false);
        this.dataTable?.requestImmediateDataRefresh();
        this.messageService.clear();
        this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: $event
        });
    }
}

export class AccountClassDS<T extends FinancialChartDetails> extends DataTableObservableDataSource<T> {

    readonly columnData: DataTableColumnData[] =
        [{displayName: 'Code', objectPropertyName: 'identifier', colWidth: '45px', textAlign: 'center'},
            {displayName: 'Name', objectPropertyName: 'name', colWidth: '70px', textAlign: 'center'},
            {displayName: 'Description', objectPropertyName: 'description'},
            {displayName: 'Status', objectPropertyName: 'status', colWidth: '60px', textAlign: 'center'},
        ];
    config: DataTableConfig;
    columnFilters: ColumnFilter[] = [];
    actions: TableAction[] = [];

    onDataExpanded(value: FinancialChartDetails): void {
    }

    constructor(readonly dataRefresher: DataTableObservableRefresher<T>,
                readonly observableErrorListener?: DataTableObservableErrorListener,
                readonly observableCompleteListener?: DataTableObservableCompletionListener,
                readonly actionListener?: (action: TableAction) => void) {
        super(() => this.dataRefresher(),
            undefined, undefined);

        this.config = {
            tableHeading: '',
            isSearchEnabled: false,
            searchPlaceHolder: '',
            emptyMessage: 'No Account Found',
            globalFilterFields: [],
            hasCheckbox: false,
            hasDetailsButton: true,
            isLazyLoadingEnabled: false,
            isPaginationEnabled: false,
            hasFilters: false,
            isExportEnabled: false,
            hasActions: false
        };
    }

    onAction(action: TableAction): void {
        if (this.actionListener) {
            this.actionListener(action);
        }
    }

    onDataFiltered(): void {
    }
}
